import { openBlock, createElementBlock, createElementVNode } from "vue";
import { _ as _export_sfc } from "./index-nOmQweDK.mjs";
const _sfc_main = {};
const _hoisted_1 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M8.55267 2.23753C10.7265 1.92085 13.2986 1.92077 15.4647 2.23761C18.7449 2.71976 21.2881 5.26092 21.7706 8.54024C21.9305 9.63226 22 10.7929 22 12C22 13.2123 21.9215 14.3714 21.7623 15.4591L21.7618 15.4625C21.2703 18.7375 18.7392 21.2798 15.457 21.7623L15.4552 21.7625C14.3597 21.9215 13.2005 22 11.9958 22C10.7913 22 9.63167 21.9215 8.54369 21.7624L8.54075 21.762C5.25506 21.2708 2.72047 18.7401 2.23783 15.4598C2.07858 14.3721 2 13.2123 2 12C2 10.7877 2.07849 9.62859 2.23774 8.54089L2.23823 8.53755C2.72982 5.26182 5.26155 2.71988 8.55186 2.23765L8.55267 2.23753Z",
  fill: "#3C75FF"
}, null, -1);
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M8.48059 1.74276L8.4804 1.74278L8.4796 1.7429L8.47936 1.74294C4.96988 2.25728 2.26785 4.97105 1.74376 8.46335L1.7435 8.46512L1.74301 8.46846L2.23774 8.54089L1.74301 8.46846C1.57985 9.58292 1.5 10.7665 1.5 12C1.5 13.2335 1.57994 14.4178 1.74311 15.5322L1.74316 15.5325C2.25802 19.032 4.96448 21.7329 8.46683 22.2565L8.46756 22.2566L8.4705 22.257L8.47132 22.2571C9.58596 22.4202 10.7699 22.5 11.9958 22.5C13.222 22.5 14.4053 22.4201 15.527 22.2574L15.5277 22.2573L15.5294 22.257L15.5297 22.257C19.0313 21.7423 21.7323 19.0279 22.2562 15.5367L22.2564 15.5358L22.2569 15.5325L22.257 15.5315C22.4202 14.4171 22.5 13.2335 22.5 12C22.5 10.7744 22.4295 9.58886 22.2653 8.46781L22.2653 8.46746C21.7506 4.9696 19.0358 2.25715 15.5375 1.74293L15.5371 1.74288C13.3229 1.419 10.7021 1.41912 8.48059 1.74276Z",
  stroke: "black",
  "stroke-opacity": "0.4",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  d: "M14.9393 12.0607C15.5251 12.6464 16.4749 12.6464 17.0607 12.0607C17.6464 11.4749 17.6464 10.5251 17.0607 9.93934L13.0607 5.93934C12.4749 5.35355 11.5251 5.35355 10.9393 5.93934L6.93934 9.93934C6.35355 10.5251 6.35355 11.4749 6.93934 12.0607C7.52513 12.6464 8.47487 12.6464 9.06066 12.0607L10.5 10.6213L10.5 17C10.5 17.8284 11.1716 18.5 12 18.5C12.8284 18.5 13.5 17.8284 13.5 17L13.5 10.6213L14.9393 12.0607Z",
  fill: "white"
}, null, -1);
const _hoisted_4 = [
  _hoisted_1,
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("click", $event))
  }, _hoisted_4);
}
const icV2BadgeUpdateRoundColor = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  icV2BadgeUpdateRoundColor as default
};
